import { BLOCKED_MODELS, ModelProviderIdentifier } from '@/consts/model-import.consts';
import { AiModelInfo, ModelService } from '@/designer/designer';
import { Model } from '@/types/nodes/model';

const SUPPORTED_MODEL_PROVIDER_SOURCES = [
  ModelProviderIdentifier.Civitai,
  ModelProviderIdentifier.FalDomain,
  ModelProviderIdentifier.FalPrefix,
  ModelProviderIdentifier.Replicate,
] as const;

/**
 * Checks if a given identifier is a valid model import identifier
 * @param identifier - The identifier to check
 */
export const isValidModelImportIdentifier = (identifier: string): boolean => {
  // Check if source is blocked
  for (const blockedModel of BLOCKED_MODELS) {
    if (identifier.includes(blockedModel)) {
      return false;
    }
  }

  // Check if URL matches supported model services
  return SUPPORTED_MODEL_PROVIDER_SOURCES.some((service) => identifier.includes(service));
};

// TODO: remove after wildcard on new architecture
export const isImportedFromProviderOld = (model: Model, service: ModelService) => model.service === service;

export const isImportedFromProvider = (model: AiModelInfo, service: ModelService) =>
  (model.type === 'imported' || model.type === 'user_defined') && model.service === service;
